__turbopack_context__.v({
  "field": "list-module__4rd5pW__field",
  "inline": "list-module__4rd5pW__inline",
  "list": "list-module__4rd5pW__list",
  "scrollable": "list-module__4rd5pW__scrollable",
});
